import { JobStopType } from '@ironsight/types'

interface JobStopLocation {
  locationId?: number | null
  stopType: JobStopType
}

export function getStopLocationId(stops: JobStopLocation[], stopType: JobStopType): number | null {
  return stops.find((stop) => stop.stopType === stopType)?.locationId ?? null
}

export function getStopLocationIds(
  stops: JobStopLocation[],
  stopType: JobStopType,
): Array<number | null> {
  return stops.filter((stop) => stop.stopType === stopType).map((stop) => stop.locationId ?? null)
}

export function getItineraryStops(stops: JobStopLocation[]) {
  return stops.map((stop, index) => ({
    locationId: stop.locationId ?? null,
    order: index,
    items: [],
  }))
}
